import * as CommType from './type'

/**
 * comm store init state
 */
export const initCommState: CommType.CommState = {
  appVersion: null,
}
